import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';

@Injectable({
  providedIn: 'root',
})
export class IonicStorageService {
  constructor(private readonly ionicStorage: Storage) {
    this.inicializar();
  }

  inicializar(){
    this.init();
  }

  async init() {
    await this.ionicStorage.create();
  }

  public async clear(deepDelete: boolean = false) {
    if (deepDelete) {
      return this.clearAll();
    }
    return this.clearSession();
  }

  public async clearSession(): Promise<boolean> {
    const clientName = await this.get('client-name');
    const clientRut = await this.get('client-rut');

    await this.ionicStorage.clear();

    await this.set('firstLoginDone', true);
    await this.set('client-name', clientName);
    await this.set('client-rut', clientRut);

    return true;
  }

  public async clearAll(): Promise<void> {
    return this.ionicStorage.clear();
  }

  public get(id: string) {
    return this.ionicStorage.get(id);
  }

  public set(id: string, data: any) {
    return this.ionicStorage.set(id, data);
  }

  public async remove(id: string) {
    await this.ionicStorage.remove(id);
  }

  public async getDataStorage(storageKey?: string) {
    if (storageKey) {
      const dataStorage = await this.get(storageKey);
      if (dataStorage) {
        return dataStorage;
      }
    }
    return null;
  }
}
